module.exports = __webpack_public_path__ + "img/market.5d35a34f.svg";